import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		card: {
			borderRadius: 8,
			border: "1px solid #DDE7E8",
		},
		content: {},
	} satisfies Record<string, CSSObject>);
